import { useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';

/**
 * The route this replaces navigated to itself and then called
 * `window.location.reload()`, which re-entered the same effect — it never
 * actually signed anyone out. Sign out, then let the Authenticator render the
 * login screen.
 */
export function Logout() {
  useEffect(() => {
    void signOut();
  }, []);

  return null;
}
